import React from 'react';
import { CellValue } from '../types';
import './Cell.css';

interface CellProps {
  value: CellValue;
  isWinning?: boolean;
  onClick: () => void;
}

const Cell: React.FC<CellProps> = ({ value, isWinning, onClick }) => {
  const cellClass = `cell ${value ? `cell-${value.toLowerCase()}` : ''} ${
    isWinning ? 'winning' : ''
  }`;

  return (
    <button className={cellClass} onClick={onClick} disabled={!!value}>
      <span>{value}</span>
    </button>
  );
};

export default Cell;
